import React from 'react'
import { useEffect } from "react";
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from 'react-bootstrap'
import NavbarComponent from './navbar'
import synergydashboard from "./images/synergydashboard.png";
import synergygradientimg from "./images/synergygradientimg.png";
import synergydashboardmobile from "./images/synergydashboardmobile.png";
import Dashboard from './interfaceDashbrd';
import synergeyicon from "./images/synergeyicon.svg";
import branchicon from "./images/branchicon.svg";
import teamicon from "./images/teamicon.svg";
import customericon from "./images/customericon.svg";
import vendoricon from "./images/vendoricon.svg";
import associateicon from "./images/associateicon.svg";
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import brand1 from "./images/brandone.png";
import brand2 from "./images/brandtwo.png";
import brand3 from "./images/brandthree.png";
import brand4 from "./images/brandfour.png";
import brand5 from "./images/brand5five.png";
import collabratehubimagembile from "./images/collabratehubimagembile.png";
import anlyticsimg from "./images/analyticreportimg.png";
import vendrimg from "./images/ventorportimg.png";
import integratedplimg from "./images/integratedplimg.png";
import purchseindentimg from "./images/purchaseindentimg.png";
import keymembersimg from "./images/keymembersimg.png";
import blackroundedarrow from "./images/blackroundedarrow.png";
import coolprateacroosimgmb from "./images/coolprateacroosimgmb.png";
import Footer from './footer';
import TabsComponent from './tap';
import { Helmet } from 'react-helmet';


export default function Synergy() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

    const features = [
        {
          title: "Seasonal Planning Management",
          description:
            "Streamline the seasonal planning process for fashion brands. Define collections and categorize them according to various parameters such as theme, target market, or product type.",
          image: brand1, // Replace with actual image path
        },
        {
          title: "Raw Material Allocation Management",
          description: "Efficiently manage raw material allocations for each collection. Allocate raw materials based on collection requirements and availability.",
          image: brand2,
        },
        {
          title: "API Integration",
          description:
            "Provide an API for sharing Season Planning data with external PLM tools. Ensure compatibility and interoperability with other PLM systems used by fashion brands.",
          image: brand3,
        },
        {
          title: "Multi-Office Collaboration",
          description:
            "Provide an API for sharing Season Planning data with external PLM tools. Ensure compatibility and interoperability with other PLM systems used by fashion brands.",
          image: brand4,
        },
        {
          title: "Scalability",
          description:
            "Ensure scalability to accommodate the growth of fashion brands. Handle increasing volumes of data and users without compromising performance.",
          image: brand5,
        },
      ];


      const [currentIndex, setCurrentIndex] = useState(0);

      const handleNext = () => {
        if (currentIndex < features.length - 1) {
          setCurrentIndex(currentIndex + 1);
        }
      };
    
      const handlePrev = () => {
        if (currentIndex > 0) {
          setCurrentIndex(currentIndex - 1);
        }
      };



      const structuredData = {
        "@context": "https://schema.org",
        "@type": "WebApplication",
        "url": "https://toodhu.com/synergy360",
        "name": "Synergy 360 - Business Networking Solutions",
        "description": "Synergy 360 is a business networking solution that optimizes supplier collaboration, vendor management, and quote requests for transparency.",
        "applicationCategory": "Business",
        "operatingSystem": "Web-based",
        "publisher": {
          "@type": "Organization",
          "name": "Toodhu",
          "logo": "https://toodhu.com/static/media/Toodhulogo.6557fdbeb7c18886ad017389da1f9e4e.svg",
          "url": "https://toodhu.com"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+91-914222981233",
          "contactType": "Customer Support",
          "areaServed": "India",
          "availableLanguage": "English"
        },
        "sameAs": [
          "https://www.facebook.com/toodhu",
          "https://www.twitter.com/toodhu",
          "https://www.instagram.com/toodhu"
        ],
        "potentialAction": {
          "@type": "Action",
          "name": "Synergy360",
          "target": "https://toodhu.com/synergy360"
        },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://toodhu.com/"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Synergy 360",
              "item": "https://toodhu.com/synergy360"
            }
          ]
        }
      };
    





  return (

<>
   <Helmet>
   <title>Business Networking Solutions for Collaboration | Synergy 360</title>
<meta charset="utf-8" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1" />
<meta name="description" content="Synergy 360 is a business networking solution that optimizes supplier collaboration, vendor management, and quote requests for transparency." />
<meta name="keywords" content="Business networking solutions, Contact management solutions, Supplier collaboration software" />
<link rel="canonical" href="https://toodhu.com/business-networking-solutions" />
<meta name="robots" content="index,follow" />
<meta property="og:title" content="Business Networking Solutions for Collaboration | Synergy 360" />
<meta property="og:site_name" content="Synergy 360" />
<meta property="og:url" content="https://toodhu.com/synergy360" />
<meta property="og:description" content="Synergy 360 is a business networking solution that optimizes supplier collaboration, vendor management, and quote requests for transparency." />
<meta property="og:type" content="website" />
<meta property="og:image" content=""/>
<meta name="twitter:card" content="summary_large_image" />
<meta name="twitter:site" content="https://toodhu.com/synergy360" />
<meta name="twitter:title" content="Business Networking Solutions for Collaboration | Synergy 360"/>
<meta name="twitter:description" content="Synergy 360 is a business networking solution that optimizes supplier collaboration, vendor management, and quote requests for transparency."/>
<meta name="twitter:image" content=""/>

<script type="application/ld+json">{JSON.stringify(structuredData)}</script>


   </Helmet>
    <div className='synergystart'>
        <div>
            <NavbarComponent/>
        </div>

        <div style={{ position: "absolute", top: "86px", right: "107px" }} id='tapcomponent'>
            <TabsComponent/>
          </div>

      <section className="container my-5 synergyfirstsec" >
      <div className="row align-items-center">
        <div className="col-lg-6">
          <h1 className="firstbuildtitlesynergy">
            Build collaborative <br /> experiences faster 
            <span className="d-block">Together.</span>
          </h1>
        </div>
        <div className="col-lg-6">
          <p className="textmuted" id='discoversynergytxt'>
          Discover endless opportunities for sourcing, connecting, and designing with our cutting-edge platform. Join us in ushering in a new era of industry collaboration. Effortlessly connect with global suppliers, request quotes with ease, and streamline your seasonal planning. Take your business to new heights with personalized tools and unparalleled networking possibilities.          </p>
          <div className="d-flex gap-3">
          <Link to="/contactform"> <button className="btn btn-dark">Start building for free</button></Link>
            {/* <a href="/synergyscreen" className="text-decoration-none">Explore UI Screens →</a> */}
          </div>
        </div>
      </div>

     <div className='synergydashboard'>
       <img  src={synergydashboard}  className='synergyboardimg'/>   

     </div>


<div className='synergydashboardmobile'>
  <img src={synergydashboardmobile}/> 
</div>


    </section>

{/* <div className='releifsec'>
    <div className='releifcentralized'>
    <img  src={synergeyicon} />  
    <div className='relieftitle'>A Relief <br />
    from Sheet works</div> 
    <div className='reliefpara'>innovative platform cum application tool designed to empower top global brands by streamlining their seasonal planning processes.</div>
    </div>

</div> */}

<div className='Synergygardinet'>
<div className='synergygradienttxt'>Synergy 360</div>
<img src={synergygradientimg} className='synergygradientimg'/>
<div className='synergygradientpara'>Synergy 360 provides endless opportunities for sourcing, connecting, and designing with an advanced platform. Easily connect with global suppliers, request quotes, and simplify your seasonal planning. With customized tools, you can boost efficiency, grow your network, and take your business to the next level.
</div>
</div>




<div className='collabrationhup'>
  <div className='premiertext'>
  Your Premier Industry <br /> <span className='premierspantxt'>Collaboration Hub!</span>
  </div>
  <div className='hublisted'>
    <div className='hublist1'>
      <img src={branchicon}/> <span className='hubbranchtxt'>Branch</span>
      <div className='bracnhlorem'>You can create multiple branches across different locations, each functioning as an independent hub while still connected to the broader network. These branches allow for localized operations with global support, enabling flexibility and efficiency in managing regional needs.</div>
    </div>

    <div className='hublist2'>
      <img src={teamicon}/> <span className='hubbranchtxt'>Team</span>
      <div className='bracnhlorem'>You can create multiple teams within each branch, each focused on specific tasks. Employees can be organized by branch, team, or department, making it easy to track roles, responsibilities, and performance. This helps improve coordination and ensures everyone works toward the branch’s goals and your business’s success.</div>
    </div>

    <div className='hublist3'>
      <img src={customericon}/> <span className='hubbranchtxt'>Customer</span>
      <div className='bracnhlorem'>You can create and manage customer profiles, tracking their specific needs and preferences. This helps you deliver personalized service, maintain strong relationships, and streamline communication, ensuring that each customer receives a tailored experience that drives satisfaction and loyalty.</div>
    </div>

    <div className='hublist4'>
      <img src={vendoricon}/> <span className='hubbranchtxt'>Vendor</span>
      <div className='bracnhlorem'>Suppliers can be added and managed within the platform, allowing you to easily request quotes, track orders, and monitor delivery timelines. By creating a dedicated supplier network, you can foster better communication and ensure the timely supply of goods and services for your operations.</div>
    </div>

    <div className='hublist5'>
      <img src={associateicon}/> <span className='hubbranchtxt'>Associate</span>
      <div className='bracnhlorem'>
      Associates can be managed similarly, helping you track partnerships, collaborations, and business alliances. Creating associate profiles allows you to maintain strong business relationships, ensuring mutual growth and success while facilitating seamless communication and joint ventures.</div>
    </div>

  </div>

</div>


<div className='collabrationhupmbile'>
    <img src={collabratehubimagembile} className='collabratehubimagembile'/>
<div className='premierhuptxt'>Your Premier Industry <span className='premiaspantxt'>Collaboration Hub!</span></div>

<div className=''>
<div className='branchhupmbilebx'>
      <img src={branchicon}/> <span className='hubbranchtxt'>Branch</span>
      <div className='bracnhlorem'>You can create multiple branches across different locations, each functioning as an independent hub while still connected to the broader network. These branches allow for localized operations with global support, enabling flexibility and efficiency in managing regional needs.</div>
    </div>   

    <div className='branchhupmbilebx'>
      <img src={teamicon}/> <span className='hubbranchtxt'>Team</span>
      <div className='bracnhlorem'>You can create multiple teams within each branch, each focused on specific tasks. Employees can be organized by branch, team, or department, making it easy to track roles, responsibilities, and performance. This helps improve coordination and ensures everyone works toward the branch’s goals and your business’s success.</div>
    </div>  

    <div className='branchhupmbilebx'>
      <img src={customericon}/> <span className='hubbranchtxt'>Customer</span>
      <div className='bracnhlorem'>You can create and manage customer profiles, tracking their specific needs and preferences. This helps you deliver personalized service, maintain strong relationships, and streamline communication, ensuring that each customer receives a tailored experience that drives satisfaction and loyalty.</div>
    </div>  

    <div className='branchhupmbilebx'>
      <img src={vendoricon}/> <span className='hubbranchtxt'>Vendor</span>
      <div className='bracnhlorem'>Suppliers can be added and managed within the platform, allowing you to easily request quotes, track orders, and monitor delivery timelines. By creating a dedicated supplier network, you can foster better communication and ensure the timely supply of goods and services for your operations.</div>
    </div>  

    <div className='branchhupmbilebx'>
      <img src={associateicon}/> <span className='hubbranchtxt'>Associate</span>
      <div className='bracnhlorem'>Associates can be managed similarly, helping you track partnerships, collaborations, and business alliances. Creating associate profiles allows you to maintain strong business relationships, ensuring mutual growth and success while facilitating seamless communication and joint ventures.</div>
    </div>  



</div>


</div>



<div className='brandlinearbg'>
      <Container className="text-center my-5 container-fluid brandasonpln" style={{ width: "87%" }}>
        <h2 className="brandplanningtxt">Brand Season Planning.</h2>
        <p className="text-white kumpatxt brandplnpara">
        Seasonal Planning in Toodhu Synergy 360 optimizes resource allocation and workflows based on seasonal trends for better decision-making and efficiency.
        </p>

        {/* Desktop View */}
        <Row className="g-4 mt-4 d-none d-md-flex">
          {features.map((feature, index) => (
            <Col key={index} xl={2} xs={12} sm={6} md={4} lg={4} className="d-flex" id='brandhup'>
              <Card className="flex-grow-1 cardbg">
                <Card.Img
                  variant="top"
                  src={feature.image}
                  alt={feature.title}
                  className="mb-3 cardimage"
                />
                <Card.Body>
                  <Card.Title>{feature.title}</Card.Title>
                  <div className='brandseson'>{feature.description}</div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Mobile View with Arrows */}
        <div className="d-block d-md-none position-relative" style={{ overflow: 'hidden' }}>
          <div className="d-flex" style={{ transform: `translateX(-${currentIndex * 100}%)`, transition: 'transform 0.3s ease', whiteSpace: 'nowrap' }}>
            {features.map((feature, index) => (
              <div key={index} className="d-inline-block" style={{ width: '100%', flex: '0 0 100%' }}>
                <Card className="cardbg" id='cardbgmobilevw' style={{ width: '100%',height: '50vh' }}>
                  <Card.Img
                    variant="top"
                    src={feature.image}
                    alt={feature.title}
                    className="mb-3 cardimage"
                  />
                  <Card.Body>
                    <Card.Title className='cardtitlembile'>{feature.title}</Card.Title>
                    <div className='brandseson'>{feature.description}</div>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </div>
          <Button className="btn-dark position-absolute" style={{ left: '28px', top: '91%', transform: 'translateY(-50%)' }} onClick={handlePrev}>&larr;</Button>
          <Button className="btn-dark position-absolute" style={{ right: '196px', top: '91%', transform: 'translateY(-50%)' }} onClick={handleNext}>&rarr;</Button>
        </div>
      </Container>
    </div>









{/* <div className='brandlinearbg'>
<Container className="text-center my-5 container-fluid brandasonpln" style={{ width: "87%" }}>
      <h2 className="brandplanningtxt">Brand Season Planning.</h2>
      <p className="text-white kumpatxt">
        Quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo<br />
        consequat. Duis aute irure dolor in reprehenderit.
      </p>
      <Row className="g-4 mt-4">
        {features.map((feature, index) => (
          <Col key={index} xl={2}  xs={12} sm={6} md={4} lg={4} className="d-flex" id='brandhup'>
            <Card className="flex-grow-1 cardbg">
              <Card.Img
                variant="top"
                src={feature.image}
                alt={feature.title}
                className="mb-3 cardimage"
              />
              <Card.Body>
                <Card.Title className="">{feature.title}</Card.Title>
                <div className='brandseson'>{feature.description}</div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>


</div> */}

{/* <section className="py-5" style={{ background: "#F5F3FF" }}>
      <div className="container text-center">
        <h2 className="collabratyiontxt">Supplier Collaboration.</h2>
        <p className="text-secondary mx-auto text-black" style={{ maxWidth: "600px" }}>
          Quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
          consequat. Duis aute irure dolor in reprehenderit.
        </p>

        <div className="row mt-4">
          <div className="col-12 col-md-6 mb-4">
            <div className="p-4 bg-white shadow d-flex align-items-center rportingbx">
              <img src={anlyticsimg} alt="Analytics" className="me-3" width="180" />
              <div>
                <h5 className="rportingbxttile">Analytics and Reporting</h5>
                <p className="rportingbxtpara mb-0">
                  Generate insights through analytics on seasonal planning data and
                  produce a comprehensive report to track information, enabling
                  informed decision-making.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-4">
            <div className="p-4 bg-white shadow  d-flex align-items-center rportingbx">
              <img src={vendrimg} alt="Vendor Optimization" className="me-3" width="180" />
              <div>
                <h5 className="rportingbxttile">Vendor Interaction <span className="text-secondary">Optimization</span></h5>
                <p className="rportingbxtpara mb-0">
                  TexDex facilitates seamless interactions with vendors through instant
                  data exchange, optimizing these interactions by enabling real-time
                  communication and collaboration.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-4">
            <div className="p-4 bg-white shadow  d-flex align-items-center rportingbx">
              <img src={integratedplimg} alt="PLM System" className="me-3" width="180" />
              <div>
                <h5 className="rportingbxttile">Integrated PLM System</h5>
                <p className="rportingbxtpara mb-0">
                  TexDex seamlessly integrates with its Product Lifecycle Management
                  (PLM) system, making global sourcing and order follow-up with vendors
                  easy and efficient.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-4">
            <div className="p-4 bg-white shadow  d-flex align-items-center rportingbx">
              <img src={purchseindentimg} alt="Purchase Indent" className="me-3" width="180" />
              <div>
                <h5 className="rportingbxttile">Purchase Indent <span className="text-secondary">Generation</span></h5>
                <p className="rportingbxtpara mb-0">
                  Instantly generate purchase indents based on raw material needs.
                  Include pricing and quantities in purchase indents for accurate
                  procurement.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> */}

<div className='fourbx'>
<section className="py-5" style={{ background: "#F5F3FF", borderRadius: "27px", marginTop: "78px" }}>

  <div className="container text-center">
    <h2 className="collabratyiontxt">Supplier Collaboration.</h2>
    <p className="text-secondary mx-auto text-black" style={{ maxWidth: "600px" }}>
    Supplier Collaboration enhances communication, streamlines order management, and improves transparency between businesses and suppliers for efficient and seamless operations.
    </p>

    <div className="row mt-4">
      {[
        { img: anlyticsimg, title: "Analytics and Reporting", desc: "Generate insights through analytics on seasonal planning data and produce a comprehensive report to track information, enabling informed decision-making.", alt: "Analytics" },
        { img: vendrimg, title: "Vendor Interaction", desc: "Texdx facilitates seamless interactions with vendors through instant data exchange, optimizing these interactions by enabling real-time communication and collaboration.", alt: "Vendor Optimization", highlight: "Optimization" },
        { img: integratedplimg, title: "Integrated PLM System", desc: "TexDx seamlessly integrates with its Product Lifecycle Management (PLM) system, making global sourcing and order follow-up with vendors easy and eicient.", alt: "PLM System" },
        { img: purchseindentimg, title: "Purchase Indent", desc: "Instantly generate purchase indents based on raw material needs. Include pricing and quantities in purchase indents for accurate procurement.", alt: "Purchase Indent", highlight: "Generation" },
      ].map((item, index) => (
        <div key={index} className="col-12 col-md-6 mb-4" id='higlightedbox'>
          <div className="p-4 bg-white shadow d-flex flex-column flex-md-row align-items-center rportingbx text-md-start text-center">
            <img src={item.img} alt={item.alt} className="me-md-3 mb-3 mb-md-0 img-fluid mbilecollptxted" width="140" />
            <div>
              <h5 className="rportingbxttile">
                {item.title} {item.highlight && <span className="text-secondary">{item.highlight}</span>}
              </h5>
              <p className="rportingbxtpara mb-0">{item.desc}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>
</div>

<br></br>
<br></br>
<br></br>

<br></br>



<div className='synergyscreen'>
<div className='interfacesectionsynergyscren'>
<div className='intermadetxtcollap' id='intermade'>Interfaces <br />
made for <span className='intermadetspanxt'>Collaboration.</span></div>
<div className='universetxtsynergy'>Built screens for Universal needs.</div>
</div>



<br></br>

<br></br>
<br></br>
<br></br>

<br></br>
<br></br>


<div className='interfacetab'>
    <div className=''>
    <Dashboard/>
    </div>

    <div className='collabrateinteface'>
       <div className='cllaparatetools'>Collaborate across <span className='teamstxt'>tools and teams</span></div>
       <div className='cllaparatepara'>Seamlessly connect and work with teams using integrated tools that enhance communication, streamline workflows, and improve productivity. Share data, manage tasks, and coordinate projects efficiently to ensure smooth collaboration across departments and business functions. </div>
      </div>


<br></br>
</div>







<div className="container-fluid  text-light py-5 keysectin ">

<div className='collprateteams'>
<div className='collprateteamstxt'>Collaborate across <span className='toolstermstxt'>tools and teams</span></div>
<div className='text-center'>Seamlessly connect and work with teams using integrated tools that enhance communication, streamline workflows, and improve productivity. Share data, manage tasks, and coordinate projects efficiently to ensure smooth collaboration across departments and business functions. </div>
<br></br>
<br></br>
<div>
  <img src={coolprateacroosimgmb}/>  
</div>
</div>





      <div className="container d-flex flex-wrap align-items-center">
        <div className="col-lg-6">
          <h2 className="keytitle">Key Membership <br /> Benefits</h2>
          <p className="mt-3 memberparatxt">
          Unlock powerful features with our membership benefits to streamline your business. Access and download the latest product catalogs, manage inventory with universal product codes (UPCs), and keep your data synchronized in real-time. Collaborate easily with teams, suppliers, and partners, and enjoy seamless support for business transactions like orders and invoicing. Stay connected and manage your business on the go with mobile accessibility. Share customized product catalogs instantly and create or update products effortlessly to keep your offerings fresh and aligned with your needs.          </p>
        </div>
        <div className="col-lg-6 d-flex flex-wrap justify-content-center position-relative">
        <img src={keymembersimg} className='keymembersimg'/>
        </div>
      </div>
    </div>

</div>








<div className=''>

</div>

<br />
<br />

<div className='gettoodhublack'>
<div className="container-fluid d-flex justify-content-center align-items-center position-relative banner-container">
      <div className="banner-content text-center">
        <h1 className="gettoodhutext">Get<br />Toodhu</h1>
       <Link to="/contactform"> <button className="btn btn-light shadow-sm rounded-pill px-4 py-2 mt-3 startbtn" >
          Start building for free <span className="ms-1"><img src={blackroundedarrow}/></span>
        </button></Link>
      </div>
    </div>
</div>



<div>
<Footer/>
</div>


{/* <div>
    <TabsComponent/>
</div> */}



    </div>
    </>



  )
}
